import * as Sentry from '@sentry/react';
import * as React from 'react';

function useHelpScoutAnalytics() {
  // biome-ignore lint/correctness/useExhaustiveDependencies: Need to check if Help Scout Beacon is loaded, otherwise we will get a type error.
  const handleOnIdentify = React.useCallback(
    (userId: string, organizationId?: string | null, organizationName?: string | null, userEmail?: string | null) => {
      try {
        if (!!window.Beacon && userEmail && userEmail !== '') {
          window.Beacon('identify', {
            name: userEmail,
            email: userEmail,
            ...(organizationName && organizationName !== '' ? { company: organizationName } : undefined),
          });

          window.Beacon('session-data', {
            user_id: userId,
            ...(organizationId && organizationId !== '' ? { organization_id: organizationId } : {}),
          });

          Sentry.addBreadcrumb({
            message: 'Help Scout identification successful',
            level: 'info',
            data: { user_id: userId, organization_id: organizationId },
          });
        } else {
          throw new Error('Help Scout Beacon is not initialized and identify is not available');
        }
      } catch (error) {
        Sentry.withScope((scope) => {
          scope.setUser({
            id: userId,
            email: userEmail ?? undefined,
          });

          scope.setExtra('organization_name', organizationName);

          Sentry.addBreadcrumb({
            message: 'Help Scout identification failed',
            level: 'warning',
            data: { user_id: userId, organization_id: organizationId },
          });
        });
      }
    },
    [!!window.Beacon],
  );

  // biome-ignore lint/correctness/useExhaustiveDependencies: Need to check if Help Scout Beacon is loaded, otherwise we will get a type error.
  const handleOnClearSession = React.useCallback(() => {
    try {
      if (window.Beacon) {
        window.Beacon('logout');
      } else {
        throw new Error('Help Scout Beacon is not initialized and logout is not available');
      }
    } catch (error) {
      Sentry.addBreadcrumb({
        message: 'Help Scout logout failed',
        level: 'warning',
      });
    }
  }, [!!window.Beacon]);

  return {
    handleOnIdentify,
    handleOnClearSession,
  };
}

export { useHelpScoutAnalytics };
